import React, { useState, useEffect } from 'react';
import { Input, Spin, Table, Space, Tooltip, Button, Modal, Popconfirm } from 'antd';
import * as AntDIcons from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { useDispatch } from 'react-redux';
import { Navigate, Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import uuid from 'react-uuid';
import {
   post_lookup, post_notice
} from '../../actions';
// import SkeletonTable from '../lesson/SkeletonTable';
// import SideCalendar from '../side-calendar/SideCalendar';
// import NoticeBoard from './NoticeBoard';
import NoticeBoardSlide from './NoticeBoardSlide';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import ResponsiveBreadcrumb from '../breadcrumb/ResponsiveBreadcrumb';
import './NoticeBoard.css';
// import moment from 'moment';
// import Overlay from '../overlay/Overlay';
import ReactHtmlParser from "react-html-parser";
import { stripQuillFormulaGuards } from '../wysiwyg/quillFormulaGuard';

function NoticeList(props) {
   const dateFormat = 'MMM. D, YYYY h:mm a';

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");
   const [createview, setCreateView] = useState(false)
   const [editview, setEditView] = useState(false)
   const [noticedefault, setNoticeDefault] = useState(null)
   const [title, setTitle] = useState("")
   const [key, setKey] = useState(null);
   const [data, setData] = useState([])
   const [loading, setLoading] = useState(true)
   const [spinning, setSpinning] = useState(false)
   const navigate = useNavigate();
   var subdomain = localStorage.getItem("lms-subdomain");
   // const NoticeDS = [
   //    {
   //       id: "00001",
   //       title: "TITLE001",
   //       content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec nisl mi, malesuada quis ex nec, mollis suscipit lorem. ",
   //       active: 1,
   //       staffid: 1,
   //    },
   //    {
   //       id: "00002",
   //       title: "TITLE002",
   //       content: "Aenean tristique odio iaculis turpis euismod commodo. Integer placerat pellentesque porta.",
   //       active: 1,
   //       staffid: 1,
   //    },
   // ];
   const dispatch = useDispatch();

   useEffect(() => {
      let urllink = `${process.env.REACT_APP_API_LESSON_LOOKUP}`
      console.log(urllink)
      axios.get(urllink).then((response) => {
         console.log(response)
         dispatch(post_lookup(response.data))
      })
      getNoticeList()
   }, []
   )
   const handleEdit = () => {

   }

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };
 
   const getNoticeList = () => {
      let user = Utils.getCurrentUserInfo(Enums.UserInfo.id)
       axios.get(`${process.env.REACT_APP_LMS_API}api/NoticeBoard/listNoticeListPerUser?userid=${user}`).then((response) => {
      //axios.get(`https://localhost:5001/api/NoticeBoard/listNoticeListPerUser?userid=${user}`).then((response) => {
         //console.log(response);

         if (response.data) {
            const data = response.data;
            var finaldata = []
            data.forEach(element => {
               var tmp = element
               var arr = tmp.filelist?.split(",")
               var imgarr = []
               arr?.forEach(el =>{
                   var path = `${process.env.REACT_APP_API_S3_URL}/${subdomain}/announcementfiles/${element.id}/${el}`
                   imgarr.push(path)
               })
               tmp.filelist ?? imgarr.join(",") 
               finaldata.push(tmp)
               // tmp.
            });
            setData(finaldata);
            setTimeout(() => {
               setLoading(false)
               console.log('stop loading')
            }, 2000);
         }
      }, (error) => {
         console.log(error.message);
         setLoading(false)
         console.log('stop loading')
      });
   }

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<AntDIcons.SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Reset
               </Button>
               <Button
                  type="link"
                  size="small"
                  onClick={() => {
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Filter
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <AntDIcons.SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const columns = [
      {
         title: 'Title',
         key: 'title',
         ...getColumnSearchProps('title'),
         render: payload => {
            return <div>
               <b>{payload.title}</b>
            </div>
         },
         width: "25%",
         // render: text => <a>{text}</a>,
      },
      {
         title: 'Content',
         dataIndex: 'content',
         key: 'content',
         // width: '30%',
         ellipsis: {
            showTitle: false,
         },
         render: content => (
            //    <Tooltip placement="topLeft" title={content}>               
            //        {content}
            //   </Tooltip>
            // <div dangerouslySetInnerHTML={{ __html: content }} style={{ textOverflow: 'ellipsis', overflow: 'hidden' }} />
            <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
               {ReactHtmlParser(stripQuillFormulaGuards(content))}
            </div>

         ),
         width: "35%",
      },
      {
         title: 'Start Date',
         key: 'start',
         render: payload => {
            return <div>
               {payload.start_date}
               {/* {moment(payload.start_date, dateFormat)} */}
            </div>
         },
         width: "15%",
         // render: text => <a>{text}</a>,
      },
      {
         title: 'End Date',
         key: 'end',
         render: payload => {
            return <div>
               {payload.end_date}
               {/* {moment(payload.end_date, dateFormat)} */}
            </div>
         },
         width: "15%",
         // render: text => <a>{text}</a>,
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return <span>
               <Space size="small">
                  <Tooltip placement="bottom" title='Edit'>
                     <AntDIcons.EditOutlined color='#4abec7' style={{ cursor: 'pointer' }} onClick={() => handleEditNoticeBoard(payload.id, payload.title, payload.content)} />
                  </Tooltip>
                  <Tooltip placement="bottom" title='Remove'>
                     <Popconfirm
                        title="Are you sure to delete this Record?"
                        onConfirm={() => handleDeleteNoticeBoard(payload.id)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No">
                        <AntDIcons.DeleteOutlined color='#4abec7' style={{ cursor: 'pointer' }} />
                     </Popconfirm>
                  </Tooltip>
                  {/* <Tooltip placement="bottom" title='View'><AntDIcons.EyeOutlined color='#4abec7' style={{ cursor: 'pointer' }} /></Tooltip> */}
               </Space>
            </span>
         },
         width: "10%",
      },
   ];

   const handleChangeTitle = () => {

   }

   const handleEditNoticeBoard = (notice_id, title, content) => {
      setSpinning(true)
         axios.get(`${process.env.REACT_APP_LMS_API}api/NoticeBoard/getNotice?id=${notice_id}`).then((response) => {
         //axios.get(`https://localhost:5001/api/NoticeBoard/getNotice?id=${notice_id}`).then((response) => {
         if (response.data) {
            console.log(response.data)
            const data = response.data;
            let noticedata = {
               id: data.id,
               title: data.title,
               content: data.content,
               active: 0,
               issection: 0,
               sectionlist: data.sectionList,
               isgradelevel: 0,
               gradelevellist: data.gradeLevelList,
               isacad: 0,
               acadlevellist: data.acadLevelList,
               staffid: 0,
               start_date: data.start_date,
               end_date: data.end_date,
               filelist : data.filelist
            };
            setNoticeDefault(noticedata);
            dispatch(post_notice(noticedata))
            setEditView(true)
            setSpinning(false)
         }
      }, (error) => {
         console.log(error.message);
         setSpinning(false)
      });

   };

   const handleDeleteNoticeBoard = (key) => {
      console.log(key);
      setSpinning(true)
      //   message.success('Click on Yes (' + key + ')');
        axios.post(`${process.env.REACT_APP_LMS_API}api/NoticeBoard/deleteNotice?id=${key}`).then((response) => {
      // axios.post(`https://localhost:5001/api/NoticeBoard/deleteNotice?id=${key}`).then((response) => {
         if (response.data) {
            const data = response.data;
            setSpinning(false)
            getNoticeList()
            Modal.success({
               title: 'Notice Board',
               content: 'Your record has been deleted.',
               centered: true,
               // onOk: refreshList(activeTab)
            });
         }
      }, (error) => {
         console.log(error.message);
         setSpinning(false)
         Modal.error({
            title: 'Notice Board',
            content: 'Error deleting record.',
            centered: true,
         });
      });
      getNoticeList()
   }

   const handleDuplicateNoticeBoard = (key) => {
      // console.log(e);
      // message.success('Click on Yes (' + key + ')');

      var o2o_mode = Utils.determineOnlineOffline(); //window.location.hostname.match(/localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|^$/gi) ? "offline" : "online";
      var newlessonid = "notice_" + o2o_mode + "_" + uuid();

      axios.post(`${process.env.REACT_APP_LMS_API}api/NoticeBoard/duplicateNotice?noticeid=${key}&newnoticeid=${newlessonid}`).then((response) => {
         if (response.data) {
            const data = response.data;
            Modal.success({
               title: 'Duplicate Lesson',
               content: 'Your lesson has been duplicated.',
               centered: true,
               // onOk: refreshList(activeTab)
            });
         }
      }, (error) => {
         console.log(error.message);
         Modal.error({
            title: 'Duplicate Lesson',
            content: 'Error duplicating lesson.',
            centered: true,
            // onOk: refreshList(activeTab)
         });
      });
   }

   const handleClick = () => {
      setCreateView(true)
   }

   return (
      // <div>
      <>
         {createview && <Navigate to={'/notice/create'} replace state={{}} />}
         {editview && <Navigate to={'/notice/edit'} replace state={{}} />}

         <Spin spinning={spinning} fullscreen tip="Loading...">
            <div className="dashboard-area-all noticeboard-page">
               <div className="dashboard-item noticeboard-shell">
                  {/* <div className="noticeboard-breadcrumb">
                     <ResponsiveBreadcrumb
                        items={[
                           // { key: 'home', node: <Link to="/home">Home</Link> },
                           { key: 'notice-board', node: 'Notice Board' },
                        ]}
                     />
                  </div> */}

                  <section className="noticeboard-overview" style={{marginTop: "15px"}}>
                     <div>
                        <span className="noticeboard-kicker">Announcements</span>
                        <h1>Notice Board</h1>
                        <p>Create, review, duplicate, and manage notices for your school community.</p>
                        <div className="noticeboard-meta">
                           <span><AntDIcons.NotificationOutlined /> {loading ? 'Loading notices' : `${data.length} notice${data.length === 1 ? '' : 's'}`}</span>
                           <span><AntDIcons.UserOutlined /> My Notices</span>
                        </div>
                     </div>
                     <div className="noticeboard-actions">
                        <Button className='button-shadow' type="primary" shape='round' icon={<AntDIcons.PlusOutlined />} onClick={handleClick}>
                           Create Notice
                        </Button>
                     </div>
                  </section>

                  <section className="noticeboard-panel">
                     <div className="noticeboard-panel-header">
                        <div>
                           <span className="noticeboard-kicker">Records</span>
                           <h2>Notice List</h2>
                        </div>
                        <div className="noticeboard-meta" style={{ marginTop: 0 }}>
                           <span>{loading ? 'Loading records' : `Total Records: ${data.length}`}</span>
                        </div>
                     </div>
                     <div className="noticeboard-table-shell">
                  {/* <SkeletonTable loading={loading} columns={columns} rowCount={1} />
                           {
                              !loading &&
                              <Table 
                              size='small' 
                              rowKey={'uid'}
                              columns={columns} 
                              dataSource={loading ? [] : data}
                              pagination={{ pageSize: 5 }}
                              />
                           } */}
                  <Table
                     loading={loading}
                     size='small'
                     rowKey={'uid'}
                     columns={columns}
                     dataSource={loading ? [] : data}
                     pagination={false}
                     // style={{ minWidth: "1000px" }}
                     scroll={{
                        // y: 'calc(100svh - 20rem)',
                        x: '1000px',
                        y: 'calc(100svh - 25rem)',
                     }}
                     footer={() => 'Total Records: ' + data.length}
                  />
                     </div>
                  </section>

               </div>
             
            </div>   
         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}
         </Spin>
      </>
      // </div>
   );
}

export default NoticeList;
